import { useQuery } from '@tanstack/react-query';
import { complaintsApi, messagesApi } from '../lib/api';
import { useAuthStore } from '../store/auth';

export function useNavigationNotifications() {
  const { tenant, user } = useAuthStore();
  const scope = [tenant?.id, user?.id];
  const options = { enabled: Boolean(tenant?.id && user?.id), staleTime: 15_000, refetchInterval: 30_000 };
  const messages = useQuery({
    ...options,
    queryKey: ['navigation-messages', ...scope],
    queryFn: async () => {
      const response = await messagesApi.getMailboxStores();
      if (response.data.showNavigationBadge === false) return 0;
      return response.data.data.reduce((sum, store) => sum + store.unreadCount, 0);
    },
  });
  const complaints = useQuery({
    ...options,
    queryKey: ['navigation-complaints', ...scope],
    queryFn: async () => (await complaintsApi.getAll({ status: 'SUBMITTED', limit: 5 })).data,
  });
  return { messages, complaints };
}
